
export const setNotification = (state, payload) => {state.notification = payload };
export const setValidateNotification = (state, payload) => { state.validateNotification = payload };
